<div id="layout" class="home f_col">
  <app-btn-choose-lang *ngIf="api.env.supportedLanguages.length > 1"  fromRoute="home" toRoute="choose-lang" bgColor="var(--slideElementBg)" color="var(--slideElementIconLClr)" [absolute]="true"></app-btn-choose-lang>
  <div class="f_col f_center f_grow f_align_c">
    <div class="f_col resp_c-50 f_align_c">
      <img id="home_logo" [ngSrc]="api.env.useGuichet ? api.env.theme.logo : (!!backOffice ? 'assets/bms.svg' : 'assets/logo.svg')" priority width="200" height="200" alt="">
      <div class="mt_40 resp_minSize_l">
        <app-button size="sm" (btnClicked)="nav.to('sign-up')">{{'createAccount' | translate}}</app-button>
        <div class="mt_10 fullWidth">
          <app-button size="sm"  class="fullWidth" (btnClicked)="nav.to('sign-in')" color="transparent" border="true">{{'alreadyAccount' | translate}}</app-button>
        </div>
        <div class="mt_10 fullWidth">
          <app-button size="xsm" *ngIf="!api.env.contactSupportMailto" (btnClicked)="api.openSupport()" color="transparent">{{'global.contact_support' | translate}}</app-button>
          <app-button size="xsm" *ngIf="api.env.contactSupportMailto" color="transparent" (btnClicked)="openMailto()">{{'global.contact_support' | translate}}</app-button>
        </div>
        <div class="fullWidth">
          <app-button size="xsm" (btnClicked)="nav.to('scan-qr')" color="transparent">{{'global.scan_qr' | translate}}</app-button>
        </div>
        <div class="fullWidth mt_20 f_center" *ngIf="api.env.hasShowcase && !api.isElectronApp">
          <app-back-btn (btnClicked)="nav.to('')"></app-back-btn>
        </div>
      </div>
    </div>
  </div>
  <div class="f_col mb_20 resp_maxSize_l">
    <app-button (btnClicked)="nav.to('sign-up')">{{'createAccount' | translate}}</app-button>
    <div class="mt_10 fullWidth">
      <app-button  class="fullWidth" (btnClicked)="nav.to('sign-in')" color="transparent" border="true">{{'alreadyAccount' | translate}}</app-button>
    </div>
    <div class="mt_10 fullWidth">
      <app-button size="sm" class="fullWidth" (btnClicked)="api.openSupport()" color="transparent">{{'global.contact_support' | translate}}</app-button>
    </div>
    <div class="fullWidth">
      <app-button size="sm" class="fullWidth" (btnClicked)="nav.to('scan-qr')" color="transparent">{{'global.scan_qr' | translate}}</app-button>
    </div>
  </div>
</div>
